import routerOptions0 from "/azp/agent/_work/5/s/frontend/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}